module.exports = __webpack_public_path__ + "static/media/12.f628e14f.jpg";